import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dark-back-button',
  templateUrl: './dark-back-button.component.html',
  styleUrls: ['./dark-back-button.component.scss']
})
export class DarkBackButtonComponent {
  @Input() paddingBottomRem = 0;
  @Output() backClicked = new EventEmitter(true);
}
